import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';

import Lab from './screens/Lab';
import Cart from './screens/Cart';

import Product from './screens/Product';
import ShareEmotion from './screens/ShareEmotion';
import Policy from './screens/Policy';
import Test from './screens/Test'; // TEST
import Privacy from './screens/Privacy';
import PrivacyAndroid from './screens/PrivacyAndroid';
import PrivacyIos from './screens/PrivacyIos';
import Terms from './screens/AppService';
import AppPage from './screens/AppPage';
import WebTicket from './screens/WebTicket';
import IDCard from './screens/IDCard';
import InsideTicket from './screens/InsideTicket';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Routes>
            <Route path='/' element={<Lab />} />
            <Route path='/lab' element={<Lab />} />
            <Route path='/lab/:product' element={<Product />} />
            <Route path='/cart' element={<Cart />} />
            <Route path='/share-emotion' element={<ShareEmotion />} />
            <Route path='/policy' element={<Policy />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path='/privacy/android' element={<PrivacyAndroid />} />
            <Route path='/privacy/ios' element={<PrivacyIos />} />
            <Route path='/app/service' element={<Terms />} />
            <Route path='/app' element={<AppPage />} />
            <Route path='/rd-ticket' element={<WebTicket />} />
            <Route path='/id-card' element={<IDCard />} />
            <Route path='/inside-ticket' element={<InsideTicket />} />
            {/* <Route path='/test' element={<Test />} /> */}
        </Routes>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
